import React, { useEffect, useState } from "react";
// import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";
import MuiLoader from "../../components/MuiLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AodIcon from "@mui/icons-material/Aod";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// swal
import Swal from "sweetalert2";

// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { red, blue, green, purple } from "@mui/material/colors";

import {
  language_change,
  usertype_change,
  topic_change,
} from "./ExtraModule.Slice";
import {
  getExtraModuleThunk,
  getExtraTopicThunk,
  updateExtraModuleThunk,
  createExtraModuleThunk,
  deleteExtraModuleThunk,
} from "./ExtraModule.Thunk";

const ExtraModulePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];

  const topic_select_option_list = useSelector(
    (state) => state.ExtraModuleSlice.topic
  );

  // ------------------------------------------
  const language = useSelector((state) => state.ExtraModuleSlice.language);
  // console.log("language-->", language);
  const usertype = useSelector((state) => state.ExtraModuleSlice.usertype);
  // console.log("usertype-->", usertype);
  const topicName = useSelector((state) => state.ExtraModuleSlice.topicName);
  const topicId = useSelector((state) => state.ExtraModuleSlice.topicId);
  // console.log("topicId---->", topicId);
  const webviewContent = useSelector(
    (state) => state.ExtraModuleSlice.webviewContent
  );
  // const [disableCreateButton, setDisableCreateButton] = useState(true);

  const disable_content_button = useSelector(
    (state) => state.ExtraModuleSlice.disable_content_button
  );

  const data = useSelector((state) => state.ExtraModuleSlice.data);
  //console.log("data--->", Object.keys(data).length);
  const _id = data.length > 0 ? data[0]["_id"] : "";

  const existing_segments = data.length > 0 ? data : [];
  // console.log("existing_segments--->",existing_segments);

  useEffect(() => {
    const load_topic_list = () => {
      dispatch(getExtraTopicThunk(usertype));
    };

    const load_data = () => {
      const params = { usertype, topicId };
      dispatch(getExtraModuleThunk(params));
    };

    load_topic_list();
    load_data();
  }, [dispatch, usertype, topicId]);

  // ------------ dropdowns on change ----------------
  const language_select_onchange = (event) => {
    dispatch(language_change(event.target.value));
  };
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };

  const topic_select_onchange = (event, value) => {
    dispatch(
      topic_change({
        topicId: event.target.value,
        topicName: value.props.children,
      })
    );
    dispatch(topic_change(event.target.value));
    const params = { usertype, topicId };
    // console.log("params-->", params);
    dispatch(getExtraModuleThunk(params));
  };

  // ---------------------------------------------------
  // -------------- Preview -----------------------
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContenttitle, setPreviewContenttitle] = useState("");
  const [previewContent, setPreviewContent] = useState("");

  const contentOnClick = (segment) => {
    setPreviewContenttitle(segment.topicName);
    setPreviewContent(segment.webviewContent);
    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };
  // ----------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ----------- create, update delete button click ----------
  const create_content_button_click = () => {
    setOperation("save");
    setContenttitle("");
    setContent("");
    setIndex(-1);
    setOpenEditor(true);
  };
  // -------------- Editor -----------------------
  const [openEditor, setOpenEditor] = useState(false);
  const [operation, setOperation] = useState("");
  const [contenttitle, setContenttitle] = useState("");
  // console.log("contenttitle-->", contenttitle);
  const [content, setContent] = useState("");
  // console.log("content--->", content);
  const [index, setIndex] = useState(-1);

  const handleCloseEditor = () => {
    setOpenEditor(false);
  };
  // -------------- Loader -----------------------
  const loading = useSelector((state) => state.ExtraModuleSlice.loading);
  // ---------------------------------------------

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, data, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setSelectedSegment(data);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedSegment({});
  };
  // ---------------------------------------------

  const update_content_button_click = (data, index) => {
    handleVertMenuClose();
    setOperation("update");
    setContenttitle(data.topicName);
    setContent(data.webviewContent);
    setIndex(index);
    setOpenEditor(true);
  };

  const saveEditorContentData = (editor_data) => {
    if (editor_data.contenttitle.length <= 0) {
      toast.error("Enter a title for this content");
    } else if (
      editor_data.content.length <= 0 ||
      editor_data.content === "<div><br></div>"
    ) {
      toast.error("Enter some contents to save");
    } else {
      if (editor_data.operation === "save") {
        
        if (data.webviewContent === "") create1stContent(editor_data);
        else createNewContent(editor_data);
        // console.log(
        //   "editor_data.operation1----------->",
        //   editor_data.operation,
        //   Object.keys(data).length,
        //   data
        // );
      } else if (editor_data.operation === "update") updateContent(editor_data); // change this function
      // console.log("editor_data.operation---->", editor_data.operation);
    }
  };

  // const saveEditorContentData = (editor_data) => {
  //   // console.log("-->    data: ", data);
  //   if (editor_data.contenttitle.length <= 0) {
  //     toast.error("Enter a title for this content");
  //   } else if (editor_data.content.length <= 0 || editor_data.content === "<div><br></div>") {
  //     toast.error("Enter some contents to save");
  //   } else {
  //     if (editor_data.operation === "save") createNewContent(editor_data);
  //     else if (editor_data.operation === "update") updateContent(editor_data); // change this function
  //   }
  // };
  // ---------------------------------------------

  const create1stContent = (editor_data) => {
    // console.log("editor_data1---->",editor_data);
    const body = {
      topicId: topicId,
      webviewContent: content,
    };
    // console.log("body--->", body);
    dispatch(createExtraModuleThunk(body))
      .then(handleCloseEditor())
      .then(() => {
        const params = { usertype, topicId };
        dispatch(getExtraModuleThunk(params));
        toast.success("Changes made successfully");
      });
  };

  const createNewContent = (editor_data) => {
    // console.log("editor_data---->",editor_data);
    let newobj = {
      topicId: topicId,
      webviewContent: editor_data.content,
    };
    // console.log("newobjcreateNewContent--->",newobj);
    const updated_segments = [...existing_segments, newobj];
    saveSegmentsIntoDatabase(newobj);
    // console.log("topicId---->", topicId);
  };
 

  const updateContent = (editor_data) => {
    let newobj = {
      topicId: topicId,
      webviewContent: editor_data.content,
    };
    saveSegmentsIntoDatabase(newobj);
  };

  const saveSegmentsIntoDatabase = (data) => {
    // console.log("data update----->",data );
    // const body = {
    //   segment: updated_segments,
    // };
    let newobj = {
      topicId: topicId,
      webviewContent: data.webviewContent,
    };
    // console.log("save segment into database---->",newobj)
    dispatch(updateExtraModuleThunk(newobj))
      .then(handleCloseEditor())
      .then(() => {
        const params = { usertype, topicId };
        dispatch(getExtraModuleThunk(params));
        toast.success("Changes made successfully");
      });
  };

  const delete_content_button_click = (data) => {
    // console.log("data--->", data);
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        data = {
          topicId: topicId,
          webviewContent: []
        }
        // console.log("data====>",data);
        deleteExtraModuleThunk(data).then((response)=>{
          // console.log("response===>",response);
          if (response.data.status === "success") {
            const params = { usertype, topicId };
            dispatch(getExtraModuleThunk(params));
            toast.success("Changes made successfully");
          }
        })

        // console.log("delete id---->", data);
      }
    });
  };

  return (
    <>
      <FormControl
        sx={{ m: 1, minWidth: 120 }}
        // style={{ marginTop: 73 }}
        size="small"
      >
        <InputLabel id="demo-select-small">Language</InputLabel>
        <Select
          labelId="demo-select-small"
          id="demo-select-small"
          // value={language}
          label="Language"
          onChange={language_select_onchange}
        >
          <MenuItem value="">None</MenuItem>
          {language_select_option_list.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
        <InputLabel id="demo-select-small">Usertype</InputLabel>
        <Select
          labelId="demo-select-small"
          id="demo-select-small"
          // value={usertype}
          label="Usertype"
          onChange={usertype_select_onchange}
        >
          <MenuItem value="">None</MenuItem>
          {usertype_select_option_list.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
        <InputLabel id="demo-select-small">Topic</InputLabel>
        <Select
          labelId="demo-select-small"
          id="demo-select-small"
          value={topicId}
          label="Usertype"
          onChange={topic_select_onchange}
        >
          <MenuItem value="">None</MenuItem>
          {topic_select_option_list.map((option) => (
            <MenuItem key={option.topicId} value={option.topicId}>
              {option.topicName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    
      {/* Show List */}
      <div>
        <Button
          onClick={create_content_button_click}
          style={{ marginTop: "-40px" }}
          variant="contained"
          disabled={disable_content_button}
        >
          Create New Content
        </Button>
        <br />
        <Box sx={{ flexGrow: 1 , marginLeft: 1}}>
          <Grid container spacing={3}>
            {/* {existing_segments.map((eachsegment, index) => ( */}
            <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
              <Card sx={{ maxWidth: 345 }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: blue[500] }}>
                      <AodIcon />
                    </Avatar>
                  }
                  action={
                    <>
                      <IconButton
                        id={index + 1.1}
                        onClick={(e) => handleVertMenuClick(e, data, index)}
                        aria-controls={openVertMenu ? { index } : undefined}
                        aria-expanded={openVertMenu ? "true" : undefined}
                        aria-haspopup="true"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </>
                  }
                  title={
                    <div
                      style={{ cursor: "pointer", wordBreak: "break-all" }}
                      onClick={() => contentOnClick(data)}
                    >
                      {data.topicName}
                      {data.content}
                      {data.contenttitle}
                    </div>
                  }
                  subheader={
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => contentOnClick(data)}
                    >
                      {data.topicId ? data.topicId : ""}
                    </div>
                  }
                />
              </Card>
            </Grid>
            {/* ))} */}
            <Menu
              id={selectedIndex}
              anchorEl={anchorEl}
              open={openVertMenu}
              onClose={handleVertMenuClose}
              MenuListProps={{
                "aria-labelledby": "vert-button",
              }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                },
              }}
            >
              <MenuItem
                onClick={() =>
                  update_content_button_click(selectedSegment, selectedIndex)
                }
              >
                Edit
              </MenuItem>
              <MenuItem
                onClick={() =>
                  delete_content_button_click(selectedSegment, selectedIndex)
                }
              >
                Delete
              </MenuItem>
            </Menu>
          </Grid>
        </Box>
      </div>

      {/* Editor */}
      <ContentEditor
        open={openEditor}
        operation={operation}
        contenttitle={contenttitle}
        setContenttitle={setContenttitle}
        content={content}
        setContent={setContent}
        index={index}
        onSave={saveEditorContentData}
        onClose={handleCloseEditor}
      />

      {/* Preview */}
      <ContentPreview
        open={openPreview}
        contenttitle={previewContenttitle}
        content={previewContent}
        onClose={handleClosePreview}
      />

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default ExtraModulePage;
